import { Box, Container, Typography, Stack, styled } from '@mui/material';
import React from 'react';

const BenefitsWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: '#F8F9FA',
  padding: theme.spacing(10, 0),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(8, 0),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(6, 0),
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: '"Nohemi", sans-serif',
  fontWeight: 600,
  fontSize: '42px',
  lineHeight: 1.2,
  color: '#181D27',
  textAlign: 'center',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    fontSize: '36px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
  },
}));

const SectionSubtitle = styled(Typography)(({ theme }) => ({
  fontFamily: '"Inter", sans-serif',
  fontWeight: 400,
  fontSize: '18px',
  lineHeight: 1.6,
  color: '#535862',
  textAlign: 'center',
  marginBottom: theme.spacing(8),
  maxWidth: '600px',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(6),
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    marginBottom: theme.spacing(4),
  },
}));

const BenefitItem = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  padding: theme.spacing(3),
}));

const BenefitIcon = styled(Box)(({ theme }) => ({
  width: '80px',
  height: '80px',
  borderRadius: '50%',
  backgroundColor: '#FFFFFF',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto',
  marginBottom: theme.spacing(3),
  fontSize: '32px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
}));

const BenefitTitle = styled(Typography)(({ theme }) => ({
  fontFamily: '"Nohemi", sans-serif',
  fontWeight: 600,
  fontSize: '20px',
  lineHeight: 1.3,
  color: '#181D27',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
  },
}));

const BenefitDescription = styled(Typography)(({ theme }) => ({
  fontFamily: '"Inter", sans-serif',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: 1.6,
  color: '#535862',
}));

const PMBenefitsSection: React.FC = () => {
  const benefits = [
    {
      icon: '🎯',
      title: 'Complete Control',
      description:
        'Have instant access to all your property information in one centralized, intelligent system.',
    },
    {
      icon: '⚡',
      title: 'Save Time',
      description:
        'Reduce manual data entry and document management by up to 80% with AI automation.',
    },
    {
      icon: '🧠',
      title: 'Smart Insights',
      description:
        'Get intelligent answers to any question about your property from your document knowledge base.',
    },
    {
      icon: '📈',
      title: 'Stay Organized',
      description:
        'Never miss important deadlines with automated calendar events and smart reminders.',
    },
  ];

  return (
    <BenefitsWrapper>
      <Container maxWidth="lg">
        <SectionTitle>Take Control of Your Property Knowledge</SectionTitle>

        <SectionSubtitle>
          Feel confident and empowered knowing every detail about your property is organized,
          accessible, and working for you.
        </SectionSubtitle>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={4}
          flexWrap="wrap"
          justifyContent="center"
        >
          {benefits.map(benefit => (
            <Box
              key={benefit.title}
              sx={{
                flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 16px)', md: '1 1 calc(25% - 24px)' },
                minWidth: { xs: 'auto', md: '200px' },
              }}
            >
              <BenefitItem>
                <BenefitIcon>{benefit.icon}</BenefitIcon>

                <BenefitTitle>{benefit.title}</BenefitTitle>

                <BenefitDescription>{benefit.description}</BenefitDescription>
              </BenefitItem>
            </Box>
          ))}
        </Stack>
      </Container>
    </BenefitsWrapper>
  );
};

export default PMBenefitsSection;
